import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullLoaderWithMsgComponent } from './full-loader-with-msg.component';
import { DirectivesModule } from '../directives/directives.module';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { LottieLoaderModule } from "../lottie-loader/lottie-loader.module";

@NgModule({
  declarations: [
    FullLoaderWithMsgComponent
  ],
  imports: [
    CommonModule,
    LottieLoaderModule
],
  exports: [
    FullLoaderWithMsgComponent,
    DirectivesModule,
    TranslationModule
  ]
})
export class FullLoaderWithMsgModule { }
